import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Is this aligned with the CBSE syllabus?", a: "Yes — SmartGuru covers the full NCERT/CBSE Class 5 to Class 9 Mathematics and Science syllabus, taught chapter by chapter exactly as it appears in school." },
  { q: "Does the voice tutor understand Indian accents?", a: "SmartGuru's voice recognition is built to understand how Indian students actually speak, so your child can talk naturally without changing their accent." },
  { q: "Will SmartGuru just give my child the answers?", a: "No — that's the whole point. SmartGuru uses the Socratic method, asking guiding questions so your child works through the problem and actually understands it, instead of copying an answer." },
  { q: "Can parents see what their child is learning?", a: "Yes, the Parent Dashboard shows chapter-by-chapter mastery, accuracy trends, focus time, and suggested next topics — always visible to parents." },
  { q: "What if my child gets a question wrong?", a: "SmartGuru's Mastery Engine detects the exact misconception behind the mistake and re-teaches that specific gap, instead of just marking it wrong." },
];

export default function LandingFAQ() {
  return (
    <section id="faq" className="py-10 sm:py-16 bg-slate-50/60 border-b border-slate-100" data-testid="landing-faq-section">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-xs font-bold uppercase tracking-widest text-primary">Questions</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl mt-2">Parent & Student FAQ</h2>
        </div>
        <Accordion type="single" collapsible className="w-full" data-testid="landing-faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-semibold">{f.q}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
